import {
  ADD_SCHOR_VERTICAL,
  EDIT_SCHOR_VERTICAL,
  LIST_SCHOR_VERTICAL,
  VIEW_SCHOR_VERTICAL,
  DELETE_SCHOR_VERTICAL,
  // text
  ADD_SCHOR_VERTICAL_TEXT,
  EDIT_SCHOR_VERTICAL_TEXT,
  LIST_SCHOR_VERTICAL_TEXT,
  VIEW_SCHOR_VERTICAL_TEXT,
  DELETE_SCHOR_VERTICAL_TEXT,
  SCHOR_VERTICAL_SUCCESS,
  SCHOR_VERTICAL_ERROR,

} from "./actionTypes"

// add schor vertical
export const addSchorVertical = (data, history, callback) => {
  return {
    type: ADD_SCHOR_VERTICAL,
    payload: { data, history, callback }
  }
}

// edit schor vertical
export const editSchorVertical = (data, id, callback) => {
  return {
    type: EDIT_SCHOR_VERTICAL,
    payload: { data, id, callback },
  }
}

// list schor vertical
export const listSchorVertical = (data, callback) => {
  return {
    type: LIST_SCHOR_VERTICAL,
    payload: { data, callback },
  }
}

// view schor vertical
export const viewSchorVertical = (data, history) => {
  return {
    type: VIEW_SCHOR_VERTICAL,
    payload: { data, history },
  }
}

// delete schor vertical
export const deleteSchorVertical = (data, callback) => {
  return {
    type: DELETE_SCHOR_VERTICAL,
    payload: { data, callback },
  }
}

// text
// add schor vertical text
export const addSchorVerticalText = (data, history, callback) => {
  return {
    type: ADD_SCHOR_VERTICAL_TEXT,
    payload: { data, history, callback }
  }
}

// edit schor vertical text
export const editSchorVerticalText = (data, id, callback) => {
  return {
    type: EDIT_SCHOR_VERTICAL_TEXT,
    payload: { data, id, callback },
  }
}

// list schor vertical text
export const listSchorVerticalText = (data, id, callback) => {
  return {
    type: LIST_SCHOR_VERTICAL_TEXT,
    payload: { data, id, callback },
  }
}

// view schor vertical text
export const viewSchorVerticalText = (data, history) => {
  return {
    type: VIEW_SCHOR_VERTICAL_TEXT,
    payload: { data, history },
  }
}

// delete schor vertical text
export const deleteSchorVerticalText = (data, callback) => {
  return {
    type: DELETE_SCHOR_VERTICAL_TEXT,
    payload: { data, callback },
  }
}

export const schorVerticalSuccess = message => {
  return {
    type: SCHOR_VERTICAL_SUCCESS,
    payload: message,
  }
}

export const schorVerticalError = message => {
  return {
    type: SCHOR_VERTICAL_ERROR,
    payload: message,
  }
}
